import Router from 'vue-router'
import index from '../components/index'
// import OrderList from '../components/OrderList'
// import Pay from '../components/Pay'
import protocol from '../components/protocol'
import protocol2 from '../components/protocol2'

import Vue from 'vue'
Vue.use(Router)
export default new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            component: index
        },
		{
		    path: '/protocol',
		    name: 'protocol',
		    component: protocol
		},
		{
		    path: '/protocol2',
		    name: 'protocol2',
		    component: protocol2
		}
		
		// ,
  //       {
  //           path: '/pay',
  //           name: 'Pay',
  //           component: Pay
  //       },
  //       {
  //           path: '/order',
  //           name: 'OrderList',
  //           component: OrderList
  //       },
		// {
		//     path: '/protocol',
		//     name: 'protocol',
		//     component: protocol
		// }
    ],
    mode: "history"
})